import type { CSSProperties, ReactNode, Ref } from "react";
import { usePostHog } from "posthog-js/react";
import { STUDIO_URL, studioImportUrl, type StudioSource } from "../studio";

interface StudioLinkProps {
  source: StudioSource;
  // From a page with a design on it, so leaving doesn't lose it: the
  // visitor is likely to come back for the file they meant to import.
  newTab?: boolean;
  className?: string;
  style?: CSSProperties;
  linkRef?: Ref<HTMLAnchorElement>;
  // Runs before the navigation, after the click is counted.
  onClick?: () => void;
  // A design for Studio to open with: an absolute PES URL and its name.
  importFile?: { url: string; name: string };
  children: ReactNode;
}

/** A link to Stitch Studio that counts the click as studio_link_clicked. */
export function StudioLink({ source, newTab, className, style, linkRef, onClick, importFile, children }: StudioLinkProps) {
  const posthog = usePostHog();
  return (
    <a
      href={importFile ? studioImportUrl(importFile.url, importFile.name) : STUDIO_URL}
      className={className}
      style={style}
      ref={linkRef}
      {...(newTab ? { target: "_blank", rel: "noopener" } : {})}
      onClick={() => {
        // sendBeacon: in the same tab the page is unloading as this sends.
        posthog?.capture("studio_link_clicked", { source, with_design: Boolean(importFile) }, { transport: "sendBeacon" });
        onClick?.();
      }}
    >
      {children}
    </a>
  );
}
